module.exports = __webpack_public_path__ + "img/CT.Bridges.Superstructure.Composite_Steel_&_Concrete_Bridge_-_Ladder_Deck_60m.Steel.91ab509f.png";